module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AwFDAc5MeBLugAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAABCSURBVDjLY2AYBXjB5kNe/wmpYSRGs6/dNkaSDMBmMy5DGElxNjZDGEn1M7ohjKRoxmYII6ma0Q1hJEczMbEzkgAAKgEexl+49qIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/stats/container/shop/tile/up.png
// module id = 905
// module chunks = 0